'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('support', {
      url: '/support',
      template: '<support></support>'      
    });
}



// WEBPACK FOOTER //
// ./client/app/support/support.routes.js